import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
	selector: 'app-radiobutton',
	template: `
<div class="full-width-field" [formGroup]="group">
<label class="radio-label-padding">{{field.label}}:</label>
<mat-radio-group [formControlName]="field.name" id="id_number">
<mat-radio-button *ngFor="let item of field.options" [value]="item.id">{{item.name}}</mat-radio-button>
</mat-radio-group>
</div>
`,
	styles: []
})
export class RadiobuttonComponent implements OnInit {
	field: FieldConfig;
	group: FormGroup;
	constructor() {}
	ngOnInit() {}
}
